module.exports = __webpack_public_path__ + "static/img/kjdy12.7362658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy12.png
// module id = 134
// module chunks = 0